// extracted by mini-css-extract-plugin
export default {"otcWrapper":"OTCInput_otcWrapper","otcInput":"OTCInput_otcInput"};